import React from "react"
import { cn } from "./cn"

// Tailwind replacement for react-bootstrap <Spinner>.
const SIZES = {
  sm: "h-4 w-4 border-2",
  md: "h-6 w-6 border-2",
  lg: "h-10 w-10 border-4",
}

export default function Spinner({ size = "md", className = "", label = "Loading…" }) {
  const s = SIZES[size] || SIZES.md
  return (
    <span
      role="status"
      className={cn("inline-block animate-spin rounded-full border-current border-r-transparent text-integria-green", s, className)}
    >
      <span className="sr-only">{label}</span>
    </span>
  )
}
